/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { CreatePortalMutationRequest, CreatePortalMutationResponse, CreatePortal400, CreatePortal401, CreatePortal403, CreatePortal404, CreatePortal409, CreatePortal500 } from "../../types/CreatePortal.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getCreatePortalUrl() {
  const res = { method: 'POST', url: `/api/stripe/portal` as const }
  return res
}

/**
 * @description Creates a Stripe Billing Portal session for the organisation admin. The portal lets the admin manage subscriptions, add/remove seats, and update billing details. Returns the portal URL to redirect the admin to.
 * @summary Create Billing Portal Session
 * {@link /api/stripe/portal}
 */
export async function createPortal(data: CreatePortalMutationRequest, config: Partial<RequestConfig<CreatePortalMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreatePortalMutationResponse, ResponseErrorConfig<CreatePortal400 | CreatePortal401 | CreatePortal403 | CreatePortal404 | CreatePortal409 | CreatePortal500>, CreatePortalMutationRequest>({ method : "POST", url : getCreatePortalUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}